export const DATE_FORMAT = 'YYYY-MM-DD'
export const INPUT_DATE_FORMAT = 'DD-MM-YYYY'
export const LONG_DATE_FORMAT = 'dddd, D MMMM YYYY'
export const SEARCH_DATE_FORMAT = 'D MMM'
export const TIME_FORMAT = 'H:mm'
export const CRYPTO_DATE_TIME_FORMAT = 'YYMMDDHHmmssSSS'
